import { Navigate, useLocation } from 'react-router-dom';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { isLiveChannel } from '@jwp/ott-common/src/utils/media';
import { liveChannelsURL } from '@jwp/ott-common/src/utils/urlFormatting';
import { useTranslation } from 'react-i18next';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';

import type { ScreenComponent } from '../../../../../types/screens';
import ErrorPage from '../../../../components/ErrorPage/ErrorPage';
import Loading from '../../../Loading/Loading';
import MediaMovie from '../MediaMovie/MediaMovie';

const MediaLiveChannel: ScreenComponent<PlaylistItem> = ({ data, isLoading, titlePath }) => {
  const liveChannelsId = isLiveChannel(data) ? data.liveChannelsId : undefined;
  const location = useLocation();
  const play = new URLSearchParams(location.search).get('play') === '1';
  const { t } = useTranslation('error');
  const { isEpgEnable } = useAppConfig();

  if (!data) {
    return <ErrorPage title={t('live_channel_not_found')} />;
  }

  if (!liveChannelsId || !isEpgEnable) {
    return <MediaMovie data={data} isLoading={false}/>;
  }
  if (data && !isLoading && liveChannelsId) {
    return <Navigate to={liveChannelsURL(liveChannelsId, data.mediaid, play, titlePath)} replace={true}></Navigate>;
  }

  return <Loading />;
};

export default MediaLiveChannel;
